import { Injectable, Injector, Inject } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';

import { O2TourComponent } from './o2-tour.component';
import { O2TourData, O2Tour_CONFIG_TOKEN, O2TourConfig } from './o2-tour-config';
import { O2TourRef } from './o2-tour-ref';
import {Router} from '@angular/router';

@Injectable()
export class O2TourService {
  private lastToast: O2TourRef;
  private path: string = '/';

  constructor(
    private router: Router,
    private overlay: Overlay,
    private parentInjector: Injector,
    @Inject(O2Tour_CONFIG_TOKEN) private toastConfig: O2TourConfig
  ) {
    router.events.subscribe((e: any) => {
      if (typeof e.url != 'undefined') {
        this.path = (e.url == '/' ? e.url : e.url.replace('/', ''));
        this.path = (this.path.indexOf('?') > -1 ? '/' : this.path);
      }
    });
  }

  show(data: O2TourData) {
    const positionStrategy = this.getPositionStrategy();
    //{ positionStrategy }
    const overlayRef = this.overlay.create({ panelClass: 'cdk-o2Tour' });
    const toastRef = new O2TourRef(overlayRef);
    this.lastToast = toastRef;
    data['page'] = this.path;
    const injector = this.getInjector(data, toastRef, this.parentInjector);
    const toastPortal = new ComponentPortal(O2TourComponent, null, injector);
    console.log(toastPortal);

    overlayRef.attach(toastPortal);

    return toastRef;
  }

  getPositionStrategy() {
    return this.overlay
      .position()
      .global()
      .top(this.getPosition())
      .right(this.toastConfig.position.right + 'px');
  }

  getPosition() {
    const lastToastIsVisible = this.lastToast && this.lastToast.isVisible();
    const position = lastToastIsVisible
      ? this.lastToast.getPosition().bottom
      : this.toastConfig.position.top;

    return position + 'px';
  }

  getInjector(data: O2TourData, toastRef: O2TourRef, parentInjector: Injector) {
    const tokens = new WeakMap();

    tokens.set(O2TourData, data);
    tokens.set(O2TourRef, toastRef);

    return new PortalInjector(parentInjector, tokens);
  }
}



// WEBPACK FOOTER //
// ./src/app/o2-tour/o2-tour.service.ts